import React from "react";
import { Admin, Resource } from "react-admin";

import { render } from "react-dom";
import { reducer as tree } from "ra-tree-ui-materialui";

import App from "./AppState";
import authProvider from "./setup/authProvider";
import dataProvider from "./setup/dataProvider";
import i18nProvider from "./setup/i18nProvider";
import customRoutes from "./routes";
import Layout from "./components/layout/Layout";
import LoginPage from "./components/Login";
import  CustomerSelector  from './modules/customers/CustomerSelector';

import * as serviceWorker from "./serviceWorker";

render(
  <App>
     <Admin
        loginPage={LoginPage}
        authProvider={authProvider}
        dataProvider={dataProvider()}
        i18nProvider={i18nProvider}
        title="Agrominera"
        locale="es"
        appLayout={Layout}
        dashboard={CustomerSelector}
        customRoutes={customRoutes}
        customReducers={{ tree }}
      >
        {permissions => [
          <Resource name="orders" />
        ]}
      </Admin>
  </App>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
